import React from 'react'
import { Loading } from '../../../redux/action';
import { connect } from 'react-redux';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import { Methods } from '../../../core/utility/methods';


const methods = new Methods();
interface Props{
    UserReducer: any;
    loading: (data: any) => void;
    emvGrowthChart:any;
}
const EmvChart:React.FC<Props> = (props: Props) => {
  const monthAbbreviations: { [key: string]: string } = {
    January: "Jan", February: "Feb", March: "Mar", April: "Apr",
    May: "May", June: "Jun", July: "Jul", August: "Aug",
    September: "Sep", October: "Oct", November: "Nov", December: "Dec"
  };

  const monthOrder: { [key: string]: number } = {
    Jan: 1, Feb: 2, Mar: 3, Apr: 4, May: 5, Jun: 6,
    Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12
  };

  // Format and sort months
    const playsOptions = {
      chart: {
        type: "line",
        height:230
      },
      title: {
        text: "",
        align:'left'

      },
      xAxis: {
        type: "datetime",
        categories: props.emvGrowthChart.map((entry:any) => entry.PERIOD),
      },
      yAxis: {
        title: {
          text: "EMV",
        },
        labels: {
          formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
            const value = Number(this.value);
            return methods.convertExactNumber(value);
          },
        },
        },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false, // Hides the export menu (dropdown)
      },
      tooltip: {
        shared: true,
        useHTML: true,
        shadow: false,
        formatter: function (this: any) {
          let header = `<div class="tooltip-box"><strong style="padding-bottom: 10px; display:block; font-size: 18px;">No. of Posts</strong>`;
          let body = this.points?.map((point: any) =>
            `<div class="tooltip-content-box">
              <span style="color:${point.color}; margin-right:10px; display:inline-flex;">\u25CF</span>
              <span class="tooltip-content-box-value">${point.series.name}: <b>${methods.convertExactNumber(point.y)}</b></span>
            </div>`
          ).join('');
          return header + body + `</div>`;
        },  
        style: {
          boxShadow: 'none',
        }
      },
      // tooltip: {
      //   useHTML: true, // allow HTML inside tooltip
      //   className: '',
      //   formatter: function (this: Highcharts.TooltipFormatterContextObject): string {
      //     return `
      //       <div class="">
      //         <strong class="tooltip-formatter-title" style="color:${this.color};">${this.series.name}</strong><br/>
      //         <span class="tooltip-formatter-value" style="font-size:13px;"><b>${methods.convertTwoPlaceExactNumber(Number(this.y))}</b></span>
      //       </div>
      //     `;
      //   },
      // },
      series: [
        {
          name: "EMV",
          data: props.emvGrowthChart.map((entry: any) => Math.round(entry.total_emv)),
        },
      ],
      
    };
  return (
    <>
                  <section className="brand-insight-highchart">
                <div className="brand-insight-highchart-top">
                  <strong className="brand-insight-highchart-title">EMV (in INR)</strong>
                </div>
                <div className="brand-insight-highchart-data">
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={playsOptions}
                  />
                </div>
              </section>
    </>
  )
}

const mapStateToProps = (state: any) => {
    return {
      UserReducer: state.UserReducer.UserData,
    };
  };
  
  const mapDispatchToProps = (dispatch: any) => {
    return {
      loading: (data: any) => dispatch(Loading(data)),
    };
  };
  
  const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(EmvChart);
  
  export { connectToRedux as  EmvChart };
  
  